import React from 'react'
import { Card, Form, Input, Row, Col, Button, Checkbox, Select, Spin, Radio, Tooltip } from 'antd'
import { CaretDownOutlined, PlusCircleFilled, FlagFilled } from '@ant-design/icons'
import ProgressBar from '../ProgressBar/ProgressBar'
import Btn from '../Button/Button'
import Modal from '../Modal/Modal'
import Info from '../assets/info-img.svg'

import './Form.scss'

const { Option } = Select

const DynamicForm = props => {
  const {
    signUp,
    login,
    label,
    enableLoginLink,
    enablePasswordLink,

    viewForm,
    cardMessage,
    formTitle,
    formSubTitle,
    formData,

    pwdResetLink,

    stepStatus,
    companyStageOneStatus,
    companyStageTwoStatus,
    finalProgressStatus,
    registrationStatus,
    productSelectionStatus,
    preQualificationStatus,

    modalView,
    handleClosePopup,
    modalType,
    modalDescription,
    redirectionLink,

    handleClickFun,
    progressLog,
    onChangeTermsConditions,
    onChangeEmailUpdates,
    handleFlags,
    footerHeight,
    inProgressItem,
    loading,
    mainLoader,
    otherFormList,

    mainContentView,
    mainContent,

    viewExternalSection,
    bodySection,

    cardFooter,
    footerDescription,

    initialFormValues,
    onFieldsChange,
    onSubmitForm,
    moreInfo,
    btnLink,
    formProps,
    grid,
  } = props

  const emailValidation = fieldName => {
    return {
      type: fieldName,
      message: 'Email is not valid!',
    }
  }

  const mobilePhoneValidation = () => {
    return {
      pattern: new RegExp('^[0-9]*$'),
      message: 'Phone number is not valid!',
    }
  }

  const passwordValidation = () => {
    const msg = (
      <div style={{ fontSize: '13px' }}>
        Password must be min 8 and max 16 Characters <br />
        long with one uppercase, one lowercase, one <br />
        numeric digit and one special character
      </div>
    )
    return {
      pattern: new RegExp('^^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,16}$'),
      message: msg,
    }
  }
  const inputTag = item => {
    return (
      <Form.Item
        hasFeedback
        key={item.fieldName}
        label={<div className="field-label">{item.label}</div>}
        name={item.fieldName}
        style={{ marginBottom: '10px' }}
        rules={[
          {
            required: item.required,
            message: 'Please complete this required field!',
          },
          item.fieldName === 'email' && emailValidation(item.fieldName),
          item.fieldName === 'mobilePhone' && mobilePhoneValidation,
          item.fieldName === 'password' && !item.logPwd && passwordValidation,
        ]}
      >
        <Input
          size="default"
          autoComplete="off"
          type={item.fieldName === 'password' ? item.fieldName : ''}
          placeholder={item.placholder}
          className="inputbox"
          style={{ width: '100%' }}
        />
      </Form.Item>
    )
  }

  const inputTextArea = item => {
    return (
      <Form.Item
        key={item.fieldName}
        label={item.label && <div className="field-label">{item.label}</div>}
        name={item.fieldName}
        style={{ marginBottom: '10px' }}
        rules={[
          {
            required: item.required,
            message: 'Please complete this required field!',
          },
        ]}
      >
        <Input.TextArea
          size="default"
          autoComplete="off"
          placeholder={item.placholder}
          className="inputbox"
          style={{ width: '100%', height: item.height }}
        />
      </Form.Item>
    )
  }

  const checkBoxTag = item => {
    const { onChangeModalCheckboxList } = props
    return (
      <div key={item.fieldName} className={item.info ? 'input-checkbox-info' : 'input-checkbox'}>
        <Form.Item name={item.fieldName} valuePropName="checked" key={item.fieldName}>
          <Checkbox value={item.fieldName} className="type-checkbox">
            <span className="checkbox-label">{item.label}</span>
          </Checkbox>
        </Form.Item>
        <div hidden={!item.info}>
          <div
            onClick={() => onChangeModalCheckboxList(item.label)}
            onKeyDown={() => onChangeModalCheckboxList(item.label)}
            role="button"
            tabIndex="0"
          >
            <img
              src={Info}
              alt="Info"
              style={{ width: '35px', marginTop: '7px', marginLeft: '-8px', cursor: 'pointer' }}
            />
          </div>
        </div>
      </div>
    )
  }

  const checkBoxGroup = item => {
    const { onChangeModalCheckboxList } = props
    return (
      <div key={item.fieldName} className="input-checkbox">
        <Form.Item name={item.fieldName}>
          <Checkbox.Group>
            {item.data.map(option => {
              return (
                <div key={option.id} style={{ marginBottom: '13px' }}>
                  <Checkbox value={option.value} className="type-checkbox">
                    <span className="checkbox-label">{option.label}</span>
                  </Checkbox>
                  <span hidden={!moreInfo}>
                    <span
                      onClick={() => onChangeModalCheckboxList(option.label)}
                      onKeyDown={() => onChangeModalCheckboxList(option.label)}
                      role="button"
                      tabIndex="0"
                    >
                      <img src={Info} alt="Info" style={{ width: '33px', cursor: 'pointer' }} />
                    </span>
                  </span>
                  {option.flag && (
                    <Tooltip placement="top" title={option.text}>
                      <FlagFilled
                        className="gl-flag-icon"
                        onClick={() => handleFlags(option.label)}
                      />
                    </Tooltip>
                  )}
                </div>
              )
            })}
          </Checkbox.Group>
        </Form.Item>
      </div>
    )
  }

  const radioBtn = info => {
    return (
      <div key={info.fieldName} className="gl-checkbox-overflow">
        <Form.Item style={{ marginBottom: '10px' }} name={info.fieldName}>
          <Radio.Group className="gl-type-radiobtn">
            {info.data.map(item => {
              return (
                <div key={item.key}>
                  <Radio value={item.value}>
                    <span style={{ fontSize: '16px' }}>{item.label}</span>
                  </Radio>
                </div>
              )
            })}
          </Radio.Group>
        </Form.Item>
      </div>
    )
  }

  const selectTag = item => {
    return (
      <Form.Item
        hasFeedback
        key={item.fieldName}
        label={<div className="field-label">{item.label}</div>}
        name={item.fieldName}
        rules={[
          {
            required: item.required,
            message: 'Please complete this required field!',
          },
        ]}
      >
        <Select
          showSearch
          style={{ width: '100%' }}
          className="cstmSelectInput"
          dropdownClassName="dropdownClassName"
          optionFilterProp="children"
          optionLabelProp="label"
          bordered={false}
          mode={item.mode}
          suffixIcon={<CaretDownOutlined style={{ fontSize: '15px', marginLeft: '-12px' }} />}
          filterOption={(input, option) =>
            option.props.label
              ? option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              : ''
          }
        >
          {item.data.map(option => {
            return (
              <Option key={option.key} value={option.value} label={option.label}>
                <div>{option.label}</div>
              </Option>
            )
          })}
        </Select>
      </Form.Item>
    )
  }

  const headerTag = item => {
    return (
      <div
        key={item.label}
        style={{
          fontSize: 16,
          fontWeight: item.weight,
          textAlign: item.textAlign,
          marginTop: item.marginTop,
          marginBottom: item.marginBottom,
        }}
      >
        {item.label}
      </div>
    )
  }

  const formList = item => {
    return (
      <Form.List
        key={item.fieldName}
        name={item.fieldName}
        rules={[
          {
            validator: async (_, names) => {
              if (!names || names.length > 5) {
                return Promise.reject(new Error('Exceeds the max limit!'))
              }
              return undefined
            },
          },
        ]}
      >
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields.map((field, index) => (
              <Form.Item
                label={index === 0 ? <div className="field-label">{item.label}</div> : ''}
                required={item.required}
                key={field.key}
                className="gl-main-form-list"
              >
                <Form.Item
                  {...field}
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[
                    {
                      required: item.required,
                      message: 'Please complete this required field!',
                    },
                  ]}
                  noStyle
                >
                  <Input
                    size="default"
                    autoComplete="off"
                    placeholder={item.placholder}
                    className="inputbox"
                    style={{ width: '100%' }}
                  />
                </Form.Item>
                {fields.length > 1 ? (
                  <Button
                    type="link"
                    style={{
                      color: '#FF5253',
                      marginLeft: '-11px',
                      fontWeight: 700,
                      fontSize: '12px ',
                      marginBottom: '-17px',
                    }}
                    onClick={() => remove(field.name)}
                  >
                    Remove
                  </Button>
                ) : null}
              </Form.Item>
            ))}
            <Form.Item className="gl-form-list">
              <Button
                type="link"
                shape="round"
                onClick={() => add()}
                style={{
                  display: 'flex',
                  color: '#323232',
                  fontSize: '21px',
                  lineHeight: 'initial',
                  padding: '0px',
                }}
                icon={
                  <PlusCircleFilled
                    className="gl-plus-icon"
                    style={{ color: '#a21e41', fontSize: '18px' }}
                  />
                }
                disabled={errors.length > 0}
              >
                <div
                  style={{
                    marginTop: '0px',
                    marginLeft: '10px',
                    fontSize: '14px',
                    fontWeight: 700,
                  }}
                >
                  {item.btnLabel || 'Add'}
                </div>
              </Button>
              <Form.ErrorList errors={errors} />
            </Form.Item>
          </>
        )}
      </Form.List>
    )
  }

  const getFields = (item, inputType) => {
    let returnResp
    switch (inputType) {
      case 'input':
        returnResp = inputTag(item)
        break
      case 'checkBox':
        returnResp = checkBoxTag(item)
        break
      case 'checkBoxGroup':
        returnResp = checkBoxGroup(item)
        break
      case 'radioBtn':
        returnResp = radioBtn(item)
        break
      case 'select':
        returnResp = selectTag(item)
        break
      case 'heading':
        returnResp = headerTag(item)
        break
      case 'formlist':
        returnResp = formList(item)
        break
      case 'textArea':
        returnResp = inputTextArea(item)
        break
      default:
        break
    }
    return returnResp
  }

  const ccSignupLink = () => {
    return (
      <div className="card-subHeader">
        Don&apos;t have an account?
        <Button type="link" onClick={() => handleClickFun('register')}>
          <div
            style={{
              color: '#262626',
              textDecoration: 'underline',
              fontWeight: 700,
              marginLeft: '-11px',
            }}
          >
            Sign up
          </div>
        </Button>
      </div>
    )
  }

  const ccLoginLink = () => {
    return (
      <div className="card-subHeader">
        Already have an account?
        <Button type="link" onClick={() => handleClickFun('login')}>
          <div
            style={{
              color: '#262626',
              textDecoration: 'underline',
              fontWeight: 700,
              marginLeft: '-11px',
            }}
          >
            Log in
          </div>
        </Button>
      </div>
    )
  }

  const passwordResetLink = () => {
    return (
      <div className="password-reset-link">
        Forgotten your password?
        <Button type="link" onClick={() => handleClickFun('reset-password')}>
          <div
            style={{
              color: '#262626',
              textDecoration: 'underline',
              fontWeight: 700,
              marginLeft: '-11px',
            }}
          >
            Reset it here
          </div>
        </Button>
      </div>
    )
  }

  return (
    <Row
      justify="space-around"
      align="middle"
      className={!signUp || !moreInfo || (!grid && 'gl-form-card')}
    >
      <Col xs={grid && 24} sm={grid && 16} md={grid && 12} lg={grid && 8}>
        <Card
          bodyStyle={{ padding: '50px' }}
          className="card-form"
          bordered={false}
          style={{
            borderRadius: '19px',
            // width: '100%',
          }}
        >
          <Spin spinning={mainLoader}>
            <Modal
              modalView={modalView}
              handleClosePopup={handleClosePopup}
              modalType={modalType}
              modalDescription={modalDescription}
            />
            {progressLog && (
              <ProgressBar
                stepStatus={stepStatus}
                companyStageOneStatus={companyStageOneStatus}
                companyStageTwoStatus={companyStageTwoStatus}
                finalProgressStatus={finalProgressStatus}
                inProgressItem={inProgressItem}
                registrationStatus={registrationStatus}
                productSelectionStatus={productSelectionStatus}
                preQualificationStatus={preQualificationStatus}
              />
            )}

            <div className="main-card-header">{formTitle}</div>
            <div className="main-card-subHeader">{formSubTitle}</div>
            {login && ccSignupLink()}
            {signUp && enableLoginLink && ccLoginLink()}
            {login && enablePasswordLink && ccSignupLink()}
            {mainContentView && <div style={{ textAlign: 'center' }}>{mainContent}</div>}

            {viewForm && (
              <Form
                layout="vertical"
                hideRequiredMark
                initialValues={initialFormValues}
                onValuesChange={onFieldsChange}
                onFinish={onSubmitForm}
                form={formProps}
              >
                {formData.map(item => {
                  return getFields(item, item.inputType)
                })}

                {signUp && (
                  <div>
                    <div className="terms-checkbox">
                      <Checkbox
                        value="accept-terms"
                        className="type-checkbox"
                        onChange={onChangeTermsConditions}
                      >
                        <span className="checkbox-options-list">I accept the</span>
                      </Checkbox>
                      <Button type="link" onClick={() => handleClickFun('terms-to-use')}>
                        <div
                          style={{
                            color: '#262626',
                            textDecoration: 'underline',
                            marginLeft: '-14px',
                            marginTop: '-10px',
                            fontSize: '12px',
                          }}
                        >
                          Terms to use
                        </div>
                      </Button>
                    </div>
                    <div>
                      <Checkbox
                        value="email-updates"
                        className="type-checkbox"
                        onChange={onChangeEmailUpdates}
                      >
                        <span className="checkbox-options-list">Sign up for email updates</span>
                      </Checkbox>
                    </div>
                  </div>
                )}
                {otherFormList && <div>{otherFormList}</div>}
                {pwdResetLink && passwordResetLink()}
                <Btn
                  label={label}
                  block="block"
                  shape="round"
                  size="large"
                  className={btnLink ? 'btnlink' : 'btn-submit'}
                  loading={loading}
                />
              </Form>
            )}

            {cardMessage && (
              <div>
                <div style={{ textAlign: 'center' }}>{cardMessage}</div>
                <Btn
                  label={label}
                  block="block"
                  shape="round"
                  size="large"
                  className="btn-submit"
                  loading={loading}
                  onClick={() => handleClickFun('submit')}
                />
              </div>
            )}

            {<div style={{ height: footerHeight }} />}
            {viewExternalSection && <div>{bodySection}</div>}
            {signUp && (
              <div>
                <div className="signup-agmt-text">By continuing, you agree to accept our</div>
                <div className="form-terms-1">
                  <Button type="link" onClick={() => handleClickFun('privacy-policy')}>
                    <div
                      style={{
                        color: '#262626',
                        textDecoration: 'underline',
                        fontSize: '12px',
                        marginRight: '-12px',
                      }}
                    >
                      Privacy Policy
                    </div>
                  </Button>
                  <span>&amp;</span>
                  <Button type="link" onClick={() => handleClickFun('terms-services')}>
                    <div
                      style={{
                        color: '#262626',
                        textDecoration: 'underline',
                        fontSize: '12px',
                        marginLeft: '-13px',
                      }}
                    >
                      Terms of Service
                    </div>
                  </Button>
                </div>
              </div>
            )}
            {redirectionLink && (
              <div style={{ textAlign: 'center', marginTop: '15px', marginBottom: '-25px' }}>
                <Button type="link" onClick={() => handleClickFun('skip-step')}>
                  <div
                    style={{
                      color: '#262626',
                      textDecoration: 'underline',
                      fontWeight: 700,
                      marginLeft: '-11px',
                      marginTop: '-5px',
                    }}
                  >
                    {redirectionLink}
                  </div>
                </Button>
              </div>
            )}
            {cardFooter && <div style={{ textAlign: 'center' }}>{footerDescription}</div>}
          </Spin>
        </Card>
      </Col>
    </Row>
  )
}

export default DynamicForm
